<template>
  <v-tab-item :value="value">
    <slot></slot>
  </v-tab-item>
</template>

<script>
export default {
  name: 'TabContent',
  props: {
    value: {
      type: [String, Number, Object],
      required: true,
    },
  },
};
</script>
